import React from 'react';
import { withAuth } from '../models/functions/with-auth';
import { Layout } from '../blocks/web/layout/layout';
import { createWebServerSideProps } from '../models/functions/create-web-server-side-props';
import { IntroContact } from '../blocks/web/intro/contact/intro-contact';
import { Contact } from '../blocks/web/contact/contact';

const ContactWeb: React.FC = () => {
    return (
        <Layout introAppearance="subpage" intro={<IntroContact />}>
            <Contact />
        </Layout>
    );
};

export const getServerSideProps = createWebServerSideProps();

export default withAuth(ContactWeb, false);
